import React, { useState, useEffect } from "react";
import { Icon, Menu, Pagination, Select, Spin, Button, Dropdown } from "antd";
import { DatePicker } from "antd";
import { connect } from "react-redux";
import moment from "moment";

import axios from "axios";
import FileSaver from "file-saver";

import UserPresenceRow from "../components/UserPresenceRow";
import { get } from "../utils/utils";
import { selectUserClients, selectUserRoleId } from "../../../redux/selectors/user";
import DateFooter from "../components/DateFooter.compontent";
import api, { fetchDistinctUsers, getCutoffProvisionalDate, getCutoffDetails, updateNextCutoffDate } from "../api/api";
import { roles } from "../../../configs/constants";
import { addOneMonth, addOneWeek, removeOneMonth, removeOneWeek } from "../utils/date.utils";

import PresenceSiege from "./PresenceSiege";

const baseURL = process.env.REACT_APP_API;

const STATES = { all: "Tous", complete: "Complet", incomplete: "Incomplet" };
const state_filter = [STATES.all, STATES.complete, STATES.incomplete];

const Presence = ({ userRoleId, token, clients, roleId, rolesList }) => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [isNoAccessDisplayed, setIsNoAccessDisplayed] = useState(false);
  const [rangeDate, setRangeDate] = useState([
    moment()
      .add(-1, "weeks")
      .startOf("month"),
    moment()
      .add(-1, "weeks")
      .endOf("month")
  ]);
  const [isCutoffDetailsLoading, setIsCutoffDetailsLoading] = useState(false);

  const [isModalCutoffDetailsOpen, setIsModalCutoffDetailsOpen] = useState(false);
  const [cutoffDetails, setCutoffDetails] = useState(null);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const [cutoffProvisionalDate, setCutoffProvisionalDate] = useState(null);
  const [areCompleteDisplayed, setAreCompleteDisplayed] = useState(STATES.all);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedUserEmail, setSelectedUserEmail] = useState(undefined);
  const [selectedUserRoleId, setSelectedUserRoleId] = useState(undefined);
  const [selectedClient, setSelectedClient] = useState(undefined);
  const [listUsers, setListUsers] = useState([]);
  const [view, setView] = useState("list");

  const filterUsers = () => {
    setFilteredUsers(
      users
        .filter(user => {
          const email = get(["user", "email"], user);
          if (selectedUserEmail) return selectedUserEmail === email;
          if (selectedClient) {
            const userClients = get(["user", "client_ids"], user, []);

            return userClients.indexOf(selectedClient) > -1;
          }
          return true;
        })
        .filter(user => {
          const email = get(["user", "email"], user);
          if (selectedUserEmail) return selectedUserEmail === email;
          if (areCompleteDisplayed === STATES.all) return true;
          const presence = get(["attendances", "pending"], user, -1);
          const vacation = get(["vacations", "pending"], user, -1);
          const trip = get(["trips", "pending"], user, -1);
          if (areCompleteDisplayed === STATES.complete) return presence === 0 && vacation === 0 && trip === 0;
          return presence > 0 || vacation > 0 || trip > 0;
        })
    );
  };

  const gaProgressBar = document.querySelectorAll(".ga-progress-bar .ant-progress-success-bg");
  for (let i = 0; gaProgressBar && i < gaProgressBar.length; i++) {
    gaProgressBar[i].style.backgroundColor = "#19C38D";
  }

  const gaBgProgressBar = document.querySelectorAll(".ga-progress-bar .ant-progress-inner");
  for (let i = 0; gaBgProgressBar && i < gaBgProgressBar.length; i++) {
    gaBgProgressBar[i].style.backgroundColor = "#f44b4b";
  }

  useEffect(() => {
    const filters = {
      page,
      match: {
        role_id: selectedUserRoleId,
        email: selectedUserEmail,
        "clients.id": selectedClient ? [selectedClient] : undefined,
        hide_attendances: false
      }
    };
    if (Array.isArray(rangeDate) && rangeDate.length === 2) {
      const startDate = rangeDate[0];
      const endDate = rangeDate[1];
      filters.start_date = startDate;
      filters.end_date = endDate;
    }

    setIsLoading(true);
    api
      .attendances()
      .progression(token, filters)
      .then(response => {
        const data = response.data || {};
        if (!Array.isArray(data.docs)) setUsers([]);
        else {
          setUsers(data.docs);
          setTotal(data.total);
        }
      })
      .catch(e => {
        console.log(e);
        setUsers([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [rangeDate, page, selectedUserEmail, selectedClient, selectedUserRoleId]);

  useEffect(() => {
    filterUsers();
    return document.removeEventListener("mousedown", handleClickOutsidePicker);
  }, [areCompleteDisplayed, selectedUserEmail, users, selectedClient]);

  const handleClickOutsidePicker = event => {
    const calendarPanel = document.querySelector(".ant-calendar");

    if (calendarPanel && !calendarPanel.contains(event.target)) {
      setIsDatePickerOpen(false);
      document.removeEventListener("mousedown", handleClickOutsidePicker);
    }
  };

  const requestGetCutoffDetails = () => {
    setIsCutoffDetailsLoading(true);
    getCutoffDetails(token).then(response => {
      if (response) {
        setCutoffDetails(response);
        setIsCutoffDetailsLoading(false);
      }
    });
  };

  useEffect(() => {
    getCutoffProvisionalDate(token).then(response => {
      if (response) {
        if (response.date) setCutoffProvisionalDate(response.date);
      } else {
        setCutoffProvisionalDate(null);
      }
    });
    requestGetCutoffDetails();
  }, []);

  const exportPresence = async function(url) {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        baseURL + url,
        { start_date: rangeDate[0], end_date: rangeDate[1] },
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: token
          }
        }
      );

      FileSaver.saveAs(new Blob([response.data], { type: "application/vnd.ms-excel" }), `Présences.xlsx`);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  const exportNDFMealPackagesUser = async ({ userId, userFullname }) => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${baseURL}/api/expenses/export/mealpackages/${userId}`,
        {},
        {
          responseType: "arraybuffer",
          headers: {
            Authorization: token
          }
        }
      );

      FileSaver.saveAs(
        new Blob([response.data], { type: "application/vnd.ms-excel" }),
        `${userFullname} forfait repas.xlsx`
      );
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="text-3xl font-bold text-gray-900">Gestion des Présences</div>

      {(roleId === roles.ADMIN || roleId === roles.DIRECTOR) && (
        <div className="flex justify-end mr-10">
          <div
            style={{ maxHeight: "35px" }}
            className={`${
              view === "siege" ? "bg-orange-500" : "bg-orange-200"
            } mt-12 rounded-full text-white py-3 px-4 mx-2 cursor-pointer`}
            onClick={() => {
              const getClient = clients.find(item => item.client_label === "COMPTA");

              if (getClient) {
                setIsNoAccessDisplayed(false);
                setSelectedClient(getClient.client_id);
              } else setIsNoAccessDisplayed(true);
              setView("siege");
            }}
          >
            Vue siège
          </div>
          <div
            style={{ maxHeight: "35px" }}
            className={`${
              view === "list" ? "bg-orange-500" : "bg-orange-200"
            } mt-12 mr-16 rounded-full text-white py-3 px-4 mx-2 cursor-pointer`}
            onClick={() => {
              setIsNoAccessDisplayed(false);
              setSelectedClient(undefined);
              setView("list");
            }}
          >
            Vue liste
          </div>
          <div className="flex flex-col pr-6 mt-4">
            <div className="flex">
              {(roleId === roles.DIRECTOR || roleId === roles.ADMIN) && (
                <div
                  className={`bg-green-400 rounded-full text-white py-3 px-4 mx-2 cursor-pointer`}
                  onClick={() => {
                    exportPresence("/api/attendances/export");
                  }}
                >
                  Télécharger
                </div>
              )}
            </div>
          </div>
          <div className="pl-6 flex flex-col border-l-2">
            <div className="flex justify-between mt-2">
              {isCutoffDetailsLoading ? (
                <div className="flex font-italic text-orange-400">En cours de chargement...</div>
              ) : (
                cutoffDetails && <div className="flex my-4">Elements validés : {cutoffDetails.percentOk} %</div>
              )}
              {(roleId === roles.DIRECTOR || roleId === roles.ADMIN) && (
                <Dropdown
                  overlay={
                    <Menu
                      onClick={({ key }) => {
                        if (key === "details") {
                          setIsModalCutoffDetailsOpen(true);
                        } else if (key === "export") {
                          exportPresence("/api/attendances/export/next");
                        }
                      }}
                    >
                      <Menu.Item key="details">
                        <Icon type="eye-o" /> Consultation
                      </Menu.Item>
                      <Menu.Item key="export">
                        <Icon type="download" /> Export fichier temporaire
                      </Menu.Item>
                    </Menu>
                  }
                >
                  <Button style={{ color: "white", float: "right" }} type="primary" size={"default"}>
                    Détails
                  </Button>
                </Dropdown>
              )}
            </div>
          </div>
        </div>
      )}
      <div className={"my-3 flex"}>
        <button
          className="rounded-full h-10 w-10 flex items-center justify-center"
          style={{ outline: "none" }}
          onClick={() => {
            setRangeDate(removeOneMonth(rangeDate));
          }}
        >
          <Icon type="double-left" />
        </button>
        <button
          className="mx-5 rounded-full h-10 w-10 flex items-center justify-center mr-4"
          style={{ outline: "none" }}
          onClick={() => {
            setRangeDate(removeOneWeek(rangeDate));
          }}
        >
          <Icon type="left" />
        </button>
        <div
          onClick={() => {
            if (!isDatePickerOpen) {
              setIsDatePickerOpen(true);
              document.addEventListener("mousedown", handleClickOutsidePicker);
            }
          }}
        >
          <DatePicker.RangePicker
            open={isDatePickerOpen}
            onChange={selectedRangeDate => {
              setIsDatePickerOpen(false);
              setRangeDate(selectedRangeDate);
            }}
            defaultValue={rangeDate}
            value={rangeDate}
            format={"DD/MM/YYYY"}
            placeholder={["Début", "Fin"]}
            renderExtraFooter={() => (
              <DateFooter
                isLoading={isLoading}
                setRangeDate={data => {
                  setRangeDate(data);
                  setIsDatePickerOpen(false);
                }}
              />
            )}
          />
        </div>
        <button
          className="mx-5 rounded-full h-10 w-10 flex items-center justify-center mr-4"
          style={{ outline: "none" }}
          onClick={() => {
            setRangeDate(addOneWeek(rangeDate));
          }}
        >
          <Icon type="right" />
        </button>
        <button
          className="rounded-full h-10 w-10 flex items-center justify-center mr-10"
          style={{ outline: "none" }}
          onClick={() => {
            setRangeDate(addOneMonth(rangeDate));
          }}
        >
          <Icon type="double-right" />
        </button>
        {view === "list" && (
          <div className="mx-2">
            <Select
              allowClear
              showSearch
              placeholder="Dossier"
              style={{ width: 200 }}
              onChange={client => {
                client ? setSelectedClient(client) : setSelectedClient(undefined);
                setSelectedUserEmail(undefined);
              }}
              value={selectedClient}
              filterOption={(input, option) => {
                return typeof option.props.children === "string"
                  ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  : false;
              }}
            >
              {clients
                .sort((a, b) => (a.client_label > b.client_label ? 1 : -1))
                .map(client => (
                  <Select.Option key={client.client_id} value={client.client_id}>
                    {client.client_label}
                  </Select.Option>
                ))}
            </Select>
          </div>
        )}
        <div className="mx-2">
          <Select
            allowClear
            showSearch
            placeholder="Personne"
            style={{ width: 200 }}
            onFocus={async () => {
              const filters = {
                match: {
                  role_id: {
                    $gte: roleId,
                    $ne: roles.CLIENT
                  },
                  clients: { $exists: true, $ne: [] },
                  "clients.id": selectedClient,
                  hide_attendances: false
                }
              };
              const response = await fetchDistinctUsers(filters, token);
              setListUsers(response);
            }}
            onChange={email => {
              email ? setSelectedUserEmail(email) : setSelectedUserEmail(undefined);
              if (view === "list") setSelectedClient(undefined);
            }}
            value={selectedUserEmail}
          >
            {listUsers.map(userEmail => (
              <Select.Option key={userEmail} value={userEmail}>
                {userEmail}
              </Select.Option>
            ))}
          </Select>
        </div>
        {(roleId === roles.DIRECTOR || roleId === roles.ADMIN) && (
          <div className="mx-2">
            <Select
              allowClear
              showSearch
              placeholder="Rôle"
              style={{ width: 200 }}
              onChange={userId => {
                userId ? setSelectedUserRoleId(userId) : setSelectedUserRoleId(undefined);
              }}
              value={selectedUserRoleId}
            >
              {rolesList &&
                rolesList.map(roleItem => (
                  <Select.Option key={roleItem.id} value={roleItem.id}>
                    {roleItem.label_fr}
                  </Select.Option>
                ))}
            </Select>
          </div>
        )}
        <div className="flex mx-2 align-middle py-1 items-center">
          {/* <Switch
            defaultChecked={false}
            onChange={() => {
              setAreCompleteDisplayed(prevValue => !prevValue);
            }}
          /> */}
          <p className="text-lg mx-4 py-1">Etat d'avancement</p>
          <Select
            allowClear
            showSearch
            placeholder="Etat"
            style={{ width: 200 }}
            onChange={state => {
              setAreCompleteDisplayed(state);
            }}
            value={areCompleteDisplayed}
          >
            {state_filter.map(state => (
              <Select.Option key={state} value={state}>
                {state}
              </Select.Option>
            ))}
          </Select>
        </div>
        {/*
        A mettre en place quand la vue macro sera en place https://app.zeplin.io/project/5d6396ee6754d79b30d7ad81/screen/5f7dc4b98511ec557c5e3c77
        <div className={"bg-orange-500 rounded-full text-white py-3 h-10 px-4 mx-2 cursor-pointer align-middle"}>
          Vue Macro
        </div> */}
      </div>
      {view === "siege" && (
        <PresenceSiege
          setSelectedClient={setSelectedClient}
          clients={clients}
          setIsNoAccessDisplayed={setIsNoAccessDisplayed}
        />
      )}
      {isNoAccessDisplayed ? (
        <div>Désolé, vous n'avez pas les accès sur ce dossier.</div>
      ) : (
        <div>
          <div className="flex flex-col my-8">
            <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
              <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <table className="min-w-full">
                  <thead>
                    <tr>
                      <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                        Nom
                      </th>
                      <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider">
                        Avancement
                      </th>
                      <th className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider text-right">
                        <span className="pr-8">Actions</span>
                      </th>
                    </tr>
                  </thead>

                  {!isLoading && (
                    <tbody className="bg-white">
                      {filteredUsers.length > 0
                        ? filteredUsers.map((user, i) => (
                            <UserPresenceRow
                              userRoleId={userRoleId}
                              key={i}
                              user={user}
                              rangeDate={rangeDate}
                              exportNDFMealPackagesUser={exportNDFMealPackagesUser}
                            />
                          ))
                        : null}
                    </tbody>
                  )}
                </table>
                {isLoading ? (
                  <div className={"flex justify-center py-10"}>
                    <Spin />
                  </div>
                ) : filteredUsers.length === 0 ? (
                  <div className="px-6 py-3">
                    {!areCompleteDisplayed ? "Aucun utilisateur avec des actions en attente" : "Pas d'utilisateur"}
                  </div>
                ) : null}
                <Pagination defaultCurrent={1} total={total} onChange={setPage} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userRoleId: state.userInfos.role_id,
    token: state.auth.token,
    clients: selectUserClients(state),
    roleId: selectUserRoleId(state),
    rolesList: (state.user && state.user.rolesList) || []
  };
};

export default connect(mapStateToProps)(Presence);



// WEBPACK FOOTER //
// src/modules/presence/presence/presence.js